import Vue from 'vue'
import { Mixins, Component, Prop, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'

import User from '@/views/User/models/user'
import UserCombobox from '@/views/Authorization/components/userCombobox/userCombobox.vue'
import ProjectUser from '@/views/Authorization/models/projectUser'
import PhoneInput from '@/_components/input/phone/phone.vue'
import ProjectContractorSelect from '@/views/Authorization/components/projectContractorSelect.vue'
import { emailRegex } from '@/_type/email'
import { postRequest } from '@/plugins/api-axios'
import { getURL } from '@/utils/axios'
import { BklrAccess } from '@/views/Authorization/types/projectUser'
import { isEmail, isMobile } from '@/utils/validation'
@Component({
    inheritAttrs: false,
    name: 'PostProjectUser',
    components: {
        DialogTemplate,
        UserCombobox,
        PhoneInput,
        ProjectContractorSelect,
    },
})
export default class PostProjectUser extends Mixins<MixinInterface>() {
    @Prop({ required: true }) props!: any

    isValidEmail(email: string) {
        return emailRegex.test(email.trim()) ? true : false
    }

    get isValidUser() {
        let res = false
        if (this.user) {
            if (typeof this.user == 'string') {
                res = this.isValidEmail(this.user)
                if (!res) res = isMobile(this.user)
            } else {
                res = true
            }
        }

        return res
    }

    user: User | string | null = this.props.user || null
    valid = false
    stepper = 1
    dateOfBirthMenu = false
    contractor = this.props.contractor || null
    virtualCardUserFormValid = false
    virtualCardUser = {
        firstName: '',
        lastName: '',
        mobile: '',
        birthDate: '',
    }
    visitorCardNumber = ''
    useVirtualCard = false

    get userPhoneNumber() {
        if (this.user instanceof User) {
            return this.user.mobileNumber || this.user.phoneNumber
        }

        return null
    }

    get hseCardExists() {
        if (!(this.user instanceof User)) return false
        return (
            Boolean(this.user.cardId) &&
            this.user.cardId !== this.user.mobileNumber &&
            this.user.cardId !== this.user.phoneNumber
        )
    }

    get isInvalid() {
        if (!this.isValidUser || !this.valid) {
            return true
        }

        if (this.useVirtualCard && !this.virtualCardUserFormValid) {
            return true
        }

        return false
    }

    get roles() {
        return this.props.roles
    }

    userRoles: string[] = []

    get validRoles() {
        return this.userRoles.length > 0
    }

    // get isEmail() {
    //     return typeof this.user == 'string' ? true : false
    // }

    isEmail = isEmail
    isMobile = isMobile

    get isNewUser() {
        return !this.props.role
    }

    get userName(): string {
        return !this.user ? '' : typeof this.user == 'string' ? this.user : this.user.name
    }

    loading = false
    jobTitle = ''
    jobDescription = ''
    mobile = ''
    email = ''
    projectUserWithMobileAlreadyExists = false

    get projectUserWithMobileAlreadyExistsValidation() {
        return this.projectUserWithMobileAlreadyExists
            ? this.$t("authorization_errors['projectUser.post.projectUserWithMobileAlreadyExists']")
            : true
    }

    @Watch('mobile')
    resetMobileError() {
        this.projectUserWithMobileAlreadyExists = false
    }

    projectUserWithEmailAlreadyExists = false

    get projectUserWithEnailAlreadyExistsValidation() {
        return this.projectUserWithEmailAlreadyExists
            ? this.$t("authorization_errors['projectUser.post.projectUserWithEmailAlreadyExists']")
            : true
    }

    @Watch('email')
    resetEmailError() {
        this.projectUserWithEmailAlreadyExists = false
    }

    @Watch('user', { deep: true })
    prefillFromUserObject() {
        if (this.user && this.user instanceof User) {
            this.mobile = this.user.mobileNumber ? this.user.mobileNumber : ''
        }
    }

    hasBklrAccess = false
    bklrAccess = {
        permission: 'standard',
        isCompanyWide: false,
        canPerformOnSiteControl: false,
        canSendSmsAlerts: false,
        cardEditPermission: 'none',
        cardsCoursesAndCertificatesPermission: 'none',
    } as BklrAccess

    permissions = [
        'standard',
        'administrator',
        'onlyReportsForCompany',
        'onlyPersonnelOnSite',
        'onlyCompaniesOnSite',
        'onlyPersonnelOnSiteAndHistory',
    ]

    cardsCoursesAndCertificatesPermission = [
        'none',
        'cardsForOwnCompany',
        'cardsForSubcontractors',
        'coursesAndCertificatesForOwnCompany',
        'coursesAndCertificatesForSubcontractors',
        'cardsCoursesAndCertificatesForOwnCompany',
        'cardsCoursesAndCertificatesForSubcontractors',
    ]

    get isPersonnelModuleDeleted() {
        return this.isModuleDeleted('personnel')
    }

    get hasValidUserForBklr() {
        return !!this.user
    }

    get hasValidBklr() {
        // If creating a project user for an existing user, the user must have an email address.
        return this.hasValidUserForBklr && this.currentProject.attributes.bklrId
    }

    handleUseVirtualCardChange(value: boolean) {
        this.useVirtualCard = value
        if (value && this.user instanceof User && !this.user['pendingDisplayName']) {
            if (this.user['name']) {
                const [firstName, ...names] = this.user['name'].split(' ')
                this.virtualCardUser.firstName = firstName || ''
                this.virtualCardUser.lastName = names?.join(' ') || ''
            }

            this.virtualCardUser.mobile = this.user.mobileNumber
        }
    }

    async testExistOnProjectUser(str: string) {
        if (!str || str.length < 2) return
        try {
            this.loading = true

            let query = {
                include: [],
                filters: {
                    'filter[userKindIfConfirmed]': 'normal',
                    'filter[project]': this.currentProjectId,
                    'filter[searchTerm]': str,
                    'page[offset]': 0,
                    'page[limit]': 1,
                },
            }

            let res = await ProjectUser.searchProjectUser(query)
            if (res.length > 0) {
                if (this.mobile == str) this.projectUserWithMobileAlreadyExists = true
                else if (this.email == str) this.projectUserWithEmailAlreadyExists = true
            }
        } finally {
            this.loading = false
        }
    }

    async nextStep(step: number) {
        if (this.projectUserWithMobileAlreadyExists) return

        if (this.mobile) await this.testExistOnProjectUser(this.mobile)
        if (this.email) await this.testExistOnProjectUser(this.email)

        if (!this.projectUserWithMobileAlreadyExists && !this.projectUserWithEmailAlreadyExists)
            this.stepper = step
    }

    async submit() {
        if (
            !this.user ||
            !this.userRoles.length ||
            this.projectUserWithMobileAlreadyExists ||
            this.projectUserWithEmailAlreadyExists
        )
            return

        this.loading = true
        let virtualCardCreatedOrExisted = false
        if (this.useVirtualCard && this.virtualCardUserFormValid) {
            try {
                await postRequest(
                    getURL({
                        path: 'virtualCards',
                        base: process.env.VUE_APP_AUTHORIZATION_BASE_URL,
                    }),
                    {},
                    {
                        type: 'virtualCard',
                        attributes: {
                            ...this.virtualCardUser,
                            birthDate: this.virtualCardUser.birthDate
                                ? this.virtualCardUser.birthDate
                                : null,
                        },
                        relationships: {
                            company: {
                                data: {
                                    type: 'company',
                                    id: this.contractor.company?.data?.id,
                                },
                            },
                        },
                    }
                )
                virtualCardCreatedOrExisted = true
            } catch (e) {
                const error = e?.data?.response?.data?.errors?.[0]
                if (error?.code === 'cardAlreadyExists') {
                    this.$store.commit('setSuccessSnackBar', {
                        subtitle: this.$t(`fe_authorization['projectUser.virtualCardExists']`, {
                            number: this.virtualCardUser.mobile,
                        }),
                        timeout: 5000,
                    })
                    virtualCardCreatedOrExisted = true
                }
            }
        }

        let data = {
            type: 'projectUser',
            attributes: {
                ...(this.jobTitle && { jobTitle: this.jobTitle }),
                ...(this.jobDescription && { jobDescription: this.jobDescription }),
                ...(typeof this.user == 'string' && isEmail(this.user) && { email: this.user }),
                ...(typeof this.user == 'string' && this.email && { email: this.email }),
                ...(typeof this.user == 'string' &&
                    this.isMobile(this.user) && { mobile: this.user }),
                ...(typeof this.user == 'string' && this.mobile && { mobile: this.mobile }),
                ...(this.hasBklrAccess &&
                    this.contractor &&
                    this.hasValidBklr && {
                        bklrAccess: {
                            permission: this.bklrAccess.permission,
                            ...(this.bklrAccess.permission == 'standard' && {
                                canPerformOnSiteControl: this.bklrAccess.canPerformOnSiteControl,
                                canSendSmsAlerts: this.bklrAccess.canSendSmsAlerts,
                                cardEditPermission: this.bklrAccess.cardEditPermission,
                            }),
                            ...(this.bklrAccess.permission == 'onlyReportsForCompany' && {
                                cardsCoursesAndCertificatesPermission:
                                    this.bklrAccess.cardsCoursesAndCertificatesPermission,
                            }),
                        },
                    }),
                ...(!this.userPhoneNumber &&
                    this.useVirtualCard &&
                    this.virtualCardUser.mobile && {
                        mobile: this.virtualCardUser.mobile,
                    }),
            },
            relationships: {
                project: {
                    data: {
                        type: 'project',
                        id: this.currentProjectId,
                    },
                },

                ...(this.user instanceof User && {
                    user: {
                        data: {
                            type: 'user',
                            id: this.user._id,
                        },
                    },
                }),

                ...(this.userRoles &&
                    this.userRoles.length > 0 && {
                        roles: {
                            data: this.userRoles.map((item) => ({
                                type: 'role',
                                id: item,
                            })),
                        },
                    }),
            },
        }

        try {
            if (this.props.forContractor) {
                let query = {
                    include: ['user', 'roles'],
                    body: { data },
                    ...(this.props.contractor && {
                        filters: { initialContractorId: this.contractor.id },
                    }),
                }

                let res = await Vue.prototype.$vbit.post('authorization', 'projectUsers', query)
                this.$emit('close', new ProjectUser(res.data, res.included))
            } else {
                // dryRun to check if bklrAccess permission granted is valid
                // ref [bklrAccess](https://authorization.devapi.vbit.com/spec/#tag/projectUser)
                // let dryRun = true
                // let res = await ProjectUser.postProjectUser(data, this.contractor, dryRun)

                // dryRun = false
                // res = await ProjectUser.postProjectUser(data, this.contractor, dryRun)
                let res = await ProjectUser.postProjectUser(data, this.contractor)

                if (virtualCardCreatedOrExisted && this.visitorCardNumber) {
                    await this.connectVisitorCard()
                }

                if (res instanceof ProjectUser) {
                    this.$emit('close', res)
                }
            }
        } finally {
            this.loading = false
        }
    }

    async connectVisitorCard() {
        if (!this.visitorCardNumber) return

        try {
            await postRequest(
                getURL({
                    path: '/visitorVirtualCardConnections',
                    base: process.env.VUE_APP_AUTHORIZATION_BASE_URL,
                }),
                {},
                {
                    type: 'visitorVirtualCardConnection',
                    attributes: {
                        mobile: this.virtualCardUser.mobile.replace(/\s/g, ''),
                        visitorCardNumber: this.visitorCardNumber,
                    },
                    relationships: {
                        project: {
                            data: {
                                type: 'project',
                                id: this.currentProjectId,
                            },
                        },
                    },
                }
            )
        } catch (e) {
            const error = e?.data?.response?.data?.errors?.[0]
            if (error?.code === 'visitorCardNotFound') {
                this.$store.commit('setSuccessSnackBar', {
                    subtitle: this.$t(`fe_authorization['projectUser.virtualCardNotFound']`),
                    timeout: 5000,
                })
            }
        }
    }

    updateContractor(contractors: any[]) {
        this.contractor = contractors[0] || null
        if (!this.contractor) {
            this.useVirtualCard = false
        }
    }

    mounted() {
        if (this.currentProject.attributes?.bklrId?.startsWith('ID06')) {
            this.permissions = ['standard', 'administrator', 'onlyReportsForCompany']
        }

        if (this.props.role) {
            this.userRoles = [this.props.role._id]
        } else if (this.props.roles.length === 1) {
            this.userRoles = [this.props.roles[0]._id]
        }
    }
}
